module.exports = "/dist/montserrat-latin-100italic.svg?c62abb675730a451d19f47f24f5425dc";


//////////////////
// WEBPACK FOOTER
// ./~/typeface-montserrat/files/montserrat-latin-100italic.svg
// module id = 67
// module chunks = 0